export const resetTitleAndUrl = (
  currentTitle: string,
  currentPermalink: string,
  resetTitle: boolean,
  resetUrl: boolean) => {
  const currentPermalinkWithoutDomain = currentPermalink.replace(/^.*\/\/[^\/]+/, "");
  if (resetTitle) { document.title = currentTitle; }
  if (resetUrl) { history.replaceState({}, currentTitle, currentPermalinkWithoutDomain); }
}
